import React, {useEffect} from 'react';
import {Helmet} from "react-helmet";
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
// import {Actions as MYACTIONS} from './store/actions/myActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';
import RegistrationForm from '../components/common/RegistrationForm'
import FeaturesSideBySide from '../components/features/FeaturesSideBySide'
import MaltaFeatures from '../components/features/MaltaFeatures'
import Team from '../components/team/Team'
import Pricing from '../components/pricing/Pricing'
import Testimonials from '../components/testimonials/Testimonials'
import Security from '../components/security/Security'
import QuizComponent from '../components/QuizComponent'


import MaltaFlag from '../assets/flags/malta.svg';

import mcDonaldsLogo from '../assets/images/mc-donalds.png';
import sixteenLogo from '../assets/images/sixteen.png';
import myokaLogo from '../assets/images/myoka.png';
import skySpiritLogo from '../assets/images/sky-spirit.png';

const questions = [
  {
    question: 'Have you done payroll before?',
    type: 'chooseMany',
    options: [
      "Yes",
      "No"
    ]
  },
  {
    question: 'How do you currently run payroll?',
    type: 'chooseOne',
    options: [
      {
        value: "We do it manually with spreadsheets",
        setFilter: {inhouse: true}
      },
      {
        value: "We are new to doing Payroll",
        setFilter: {inhouse: true}
      },
      {
        value: "We currently use another software",
        setFilter: {inhouse: true}
      },
      {
        value: "We currently outsource our payroll",
        setFilter: {inhouse: false}
      },
    ]
  },
  {
    question: 'Which of these do you relate to most?',
    type: 'chooseMany',
    filter: {inhouse: true},
    options: [
      "I take too long to get payroll done",
      "I’m afraid of making mistakes in my payroll",
      "Our Staff do not understand their payslips",
      "We're overwhelmed with Staff Queries after payroll",
    ]
  },
  {
    question: 'Which of these do you relate to most?',
    type: 'chooseMany',
    filter: {inhouse: false},
    options: [
      "Our Payroll takes too long",
      "Our payslips are missing leave and other required items",
      "It's a struggle to obtain payslips and send them to staff",
      "Our service provider is getting expensive",
    ]
  },
  {
    question: "What's the nature of the business?",
    type: 'chooseOne',
    options: [
      "We work in retail or food service",
      "We work in an office ",
      "Construction business, field or factory settings",
    ]
  }
]


function IsBuddyForYou({
  questionsReady
}) {


  return (

    <React.Fragment>

      <Helmet>
          <title>Automated payroll solutions, geared to save you time and money | Buddy</title>
          <meta name="description" content="Malta's easiest payroll software, learn how payroll can be easier. Free Demo Available." />
          <link rel="canonical" href={`https://www.buddy.hr`} />
          <html lang="en-MT" amp />
      </Helmet>
      <main className="mt-8 sm:mt-16 md:mt-20 lg:mb-24 mb-8 sm:mb-16 md:mb-20 lg:mb-24">
        <div className="mx-auto max-w-screen-xl">
          <div className="lg:grid lg:grid-cols-12 lg:gap-8">
            <div className="px-4 sm:px-6 text-center mx-auto lg:col-span-8 lg:col-start-3">
              <div>
                <h1 className="mt-4 text-4xl tracking-tight leading-10 font-extrabold text-white sm:mt-5 sm:leading-none sm:text-6xl lg:mt-6 lg:text-5xl xl:text-6xl">
                  We made doing payroll
                  <br />
                  a breeze.
                  <br />
                  <span className="text-orange-400 lg:text-3xl xl:text-4xl">see how</span>
                </h1>
                {/*<p className="mt-3 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                  Buddy's easy to use payroll software is guaranteed to simplify and speed up your payroll process. Our software does all the heavy lifting, allowing you to focus on your business.
                </p>*/}
              </div>
            </div>
          </div>
        </div>
      </main>

      <QuizComponent questions={questions} />

      {/*<div className="bg-orange-600">
        <div className="max-w-2xl mx-auto text-center py-16 px-4 sm:py-20 sm:px-6 lg:px-8">
          <h2 className="text-3xl leading-9 font-extrabold text-white sm:text-4xl sm:leading-10">
            <span className="block">Want to level-up your payroll?</span>
            <span className="block">Talk to an expert</span>
          </h2>
          <a target="_blank" href="https://calendly.com/buddy-intro/strategy" className="mt-8 w-full inline-flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-orange-600 bg-white hover:text-orange-500 hover:bg-orange-50 transition duration-150 ease-in-out sm:w-auto">
            Schedule a call now
          </a>
          <a href="tel:+35620331199,2" className="block text-white text-xs mt-4">
            or call on <span style={{textDecoration:"underline"}}>+356 2033 1199</span>  between 9am - 5pm
          </a>
          <p className="mt-4 text-xs leading-1 text-orange-200">We'll take 15min of your time to understand if you're someone our payroll solution can help. <br/> This is a no-commitment call and comes at no charge.</p>
        </div>
      </div>*/}

      <FeaturesSideBySide 
        payslipPreview={true}
        title="Automate your payroll process quickly, securely and at scale."
        intro="Go beyond the time-consuming task of physically collating timesheets and preparing payroll. Automate it with Buddy and focus on growing your business."
        />
      <MaltaFeatures/>
      { questionsReady && <Pricing/> }
      <Testimonials/>
      { questionsReady && <Security/>}
      { questionsReady && <Team/>}

    </React.Fragment>
    
  );
}

const mapStateToProps = (state) => {

  const questionIndex = state.quiz.index
  const questionFilter = state.quiz.filter

  const questionsToUse = Object.keys(questionFilter).length == 0 ? questions : questions.filter(q => !q.filter || !Object.keys(questionFilter).find((k) => questionFilter[k] != q.filter[k]))

  const questionsReady = questionIndex >= questionsToUse.length


  // const {
  //   myAgreements,
  // } = state.my


  return {
    questionsReady,
    // showSidebar: state.sidebar.show,
    // loggedIn: state.my.profile ? true : false,
  }
}

const mapDispatchToProps = dispatch => ({
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IsBuddyForYou) 
